const ICON_COLORS = [
  {
    // Network site-operational bg-cs-orange-600 / bg-cs-orange-100
    match: (s) => s.networkCount > 1 && s.isActive,
    colors: {icon: '#FFFFFF', icon_bg: '#D26107', headline_bg: '#FEF1EA'},
  },
  {
    // Network site-on hold transparent/bg-cs-gray-200
    match: (s) => s.networkCount > 1 && !s.isActive,
    colors: {icon: '#1f2937', icon_bg: '', headline_bg: '#E5E7EB'},
  },
  {
    // Single sites - operational bg-cs-blue-600 / bg-cs-blue-100
    match: (s) => s.networkCount <= 1 && s.isActive,
    colors: {icon: '#FFFFFF', icon_bg: '#2868A5', headline_bg: '#DBEBFF'},
  },
  {
    // Single sites - cs-gray-800 / bg-cs-gray-200
    match: (s) => s.networkCount <= 1 && !s.isActive,
    colors: {icon: '#FFFFFF', icon_bg: '#1f2937', headline_bg: '#E5E7EB'},
  },
];

export function getSiteSiteColors(site) {
  if (!site) return {icon: 'red', icon_bg: 'green', headline_bg: '#E5E7EB'};
  return ICON_COLORS.find((r) => r.match(site.properties))?.colors ?? {
    icon: '#1f2937',
    icon_bg: '',
    headline_bg: '#E5E7EB'
  };
}
